

const Cache = require('./Cache');
const Diad = require('./Diad');

function SudokuStrategy(name, determineFn) {
    this.name = name;
    this.determinePossibilities = determineFn;
    this.cache = new Cache(`${name}-strategy-cache`);
}

SudokuStrategy.prototype.determinePossibilities = function (cell, grid) {
    console.warn('You must implement this yourself');
};

SudokuStrategy.prototype._determine = function (key, grid, loader) {
    return this.cache.get(grid.getState(), key, loader);
};

SudokuStrategy.Simple = new SudokuStrategy('simple', function (cell, grid) {
    if (cell.getValue()) {
        return [cell.getValue()];
    }
    const taken = {};
    grid.getRelatedCells(cell).forEach((neighbor) => {
        if (neighbor.getValue()) {
            taken[neighbor.getValue()] = true;
        }
    });
    const possibilities = [];
    for (let i = 1; i < 10; i++) {
        if (!taken[i]) {
            possibilities.push(i);
        }
    }
    return possibilities;
});


SudokuStrategy.DiadAware = new SudokuStrategy('diadAware', function (cell, grid) {
    if (cell.getValue()) {
        return [cell.getValue()];
    }

    const groups = grid.getRelationGroups(cell);

    const eliminable = [];
    groups.forEach((neighbors) => {
        const diads = [];

        neighbors.forEach((neighbor) => {
            if (neighbor === cell) return;
            const neighborPossibilities = this._determine(`simple${neighbor.name}`, grid, () => {
                return SudokuStrategy.Simple.determinePossibilities(neighbor, grid);
            });
            if (neighborPossibilities.length === 2) {
                diads.push(new Diad(neighborPossibilities));
            }
        });

        const groupCount = {};
        diads.forEach((diad) => {
            if (!groupCount[diad.asKey()]) {
                groupCount[diad.asKey()] = {
                    diad,
                    count: 0
                };
            }
            groupCount[diad.asKey()].count += 1;
        });
        for (const key in groupCount) {
            if (groupCount.hasOwnProperty(key) && groupCount[key].count === 2) {
                eliminable.push(groupCount[key].diad.getValues()[0], groupCount[key].diad.getValues()[1]);
            }
        }
    });

    const mySimplePossibilities = this._determine(`simple${cell.name}`, grid, () => {
        return SudokuStrategy.Simple.determinePossibilities(cell, grid);
    });

    const myDiadAwarePossibilities = [];
    mySimplePossibilities.forEach((possibility) => {
        if (eliminable.includes(possibility)) return;
        myDiadAwarePossibilities.push(possibility);
    });

    return myDiadAwarePossibilities;
});

module.exports = SudokuStrategy;

